// "Schritt 1 von 2" for flows that span two pages (Bezugspersonenbogen → Schweigepflichtentbindung):
// numbered circles with labels, done steps ticked, the current one highlighted.
import { Check } from 'lucide-react'
import { cn } from '../utils/cn'

interface StepIndicatorProps {
  steps: string[]
  /** 0-based index of the current step; steps.length = everything done */
  current: number
  /** e.g. "Schritt 1 von 2" — read by screen readers, shown above */
  caption: string
}

export function StepIndicator({ steps, current, caption }: StepIndicatorProps) {
  return (
    <nav aria-label={caption} className="mb-6">
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground text-center mb-3">{caption}</p>
      <ol className="flex items-start">
        {steps.map((label, i) => {
          const done = i < current
          const active = i === current
          return (
            // min-w-0: equal columns even with a long label, so the connecting line runs circle to circle
            <li key={label} className="flex-1 min-w-0 flex flex-col items-center text-center relative" aria-current={active ? 'step' : undefined}>
              {i > 0 && <span aria-hidden className={cn('absolute top-4 right-1/2 w-full h-0.5 -z-0', i <= current ? 'bg-primary' : 'bg-border')} />}
              <span className={cn(
                'relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-small font-semibold border-2',
                done ? 'bg-primary border-primary text-white' : active ? 'bg-white border-primary text-primary' : 'bg-white border-border text-muted-foreground',
              )}>
                {done ? <Check className="w-4 h-4" /> : i + 1}
              </span>
              <span className={cn('mt-2 text-small px-2 break-words hyphens-auto', active ? 'font-semibold text-foreground' : done ? 'text-foreground' : 'text-muted-foreground')}>{label}</span>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
